import ApiService from "service/Api";
import { TierPayloadTypes } from "utilities/types/Tier";
import { TierRewardPayloadTypes } from "utilities/types/TierReward";

const TierService = {
  getAllTiers: async (filterTenant: number) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        filter_tenant: filterTenant,
      },
      url: "/admin/tiers",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeTier: async (payload: TierPayloadTypes) => {
    const {
      tierName,
      tierBackground,
      pointsLow,
      pointsHigh,
      maxCollectPointPerWeek,
      maxCollectPointPerMonth,
      minTransaction,
      tierIcon,
      tierCard,
      tierCardTemplate,
      tenantId,
    } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        tier_name: tierName,
        tier_background: tierBackground,
        points_low: pointsLow,
        points_high: pointsHigh,
        max_collect_point_per_week: maxCollectPointPerWeek,
        max_collect_point_per_month: maxCollectPointPerMonth,
        transactions_low: minTransaction,
        tier_icon: tierIcon,
        tier_card: tierCard,
        tier_card_template: tierCardTemplate,
        tenant_id: tenantId,
      },
      url: "/admin/tiers",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateTier: async (tierId: string, payload: TierPayloadTypes) => {
    const {
      tierName,
      tierBackground,
      pointsLow,
      pointsHigh,
      maxCollectPointPerWeek,
      maxCollectPointPerMonth,
      minTransaction,
      tierIcon,
      tierCard,
      tierCardTemplate,
      tenantId,
    } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        tier_name: tierName,
        tier_background: tierBackground,
        points_low: pointsLow,
        points_high: pointsHigh,
        max_collect_point_per_week: maxCollectPointPerWeek,
        max_collect_point_per_month: maxCollectPointPerMonth,
        transactions_low: minTransaction,
        tier_icon: tierIcon,
        tier_card: tierCard,
        tier_card_template: tierCardTemplate,
        tenant_id: tenantId,
        _method: "PUT",
      },
      url: "/admin/tiers/" + tierId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteTier: async (tierId: string) => {
    const requestData = {
      method: "delete",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/tiers/" + tierId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  getTierRewardByTierName: async (tierName?: string) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/tiers/" + tierName,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeTierRewards: async (
    tierId: string | undefined,
    payload: TierRewardPayloadTypes
  ) => {
    const { catalogs } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        catalogs: catalogs,
      },
      url: "/admin/tiers/" + tierId + "/add-rewards",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteTierReward: async (
    tierId: string | undefined,
    tierRewardId: number
  ) => {
    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      data: {
        tier_reward_id: tierRewardId,
      },
      url: "/admin/tiers/" + tierId + "/remove-reward",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default TierService;
